export function isDefined<T>(o?: T | undefined | null): o is NonNullable<T> {
    return typeof o !== 'undefined'
        && o !== null;
}
